import React from 'react';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import { translate } from 'react-i18next';
import { Column, Container, Row } from '../../src/components/Grid';
import Icon from '../../src/components/Icon';
import { Section } from '../../src/components/Layout';
import { H3 } from '../../src/components/Title';
import routes from '../../conf/routes';
import { getPageBuilderByType } from '../../src/apollo/graphql/page/getPageBuilder';
import createContext from '../../src/utils/format/createContext';
import Text from '../../src/components/Typography/Text';
import theme from '../../src/theme';
import Button from '../../src/components/Button';

const Link = styled.a``;

const Push = styled.div`
  .icon-arrow-right {
    transition: transform 200ms ease;
  }

  img {
    object-fit: cover;
    font-family: 'object-fit: cover;';
    min-height: 250px;
    width: 100%;
  }

  a {
    display: flex;
    margin-top: 5px;
    text-decoration: none;
    color: ${props => props.theme.color.primary};
    i {
      margin-left: 12px;
    }
  }

  span {
    margin-top: 10px;
    display: block;
  }

  &:hover {
    .icon-arrow-right {
      transform: translateX(5px);
    }
  }
`;

class PushDiscover extends React.PureComponent {
  render() {
    const { t, i18n } = this.props;
    const pathname = routes.generic.langs[i18n.language].split('/')[0];
    return (
      <Section>
        <Container>
          <Fade up>
            <H3 icon="discover" border={true}>
              {t('common:place.related')}
            </H3>
          </Fade>
          <Fade up>
            <Row space={10}>
              <Column mobile={2} desktop={4} space={10}>
                <Query
                  query={getPageBuilderByType}
                  context={createContext(i18n.language)}
                  variables={{ type: 'hotel' }}
                >
                  {({ loading, error, data }) => {
                    if (
                      !loading &&
                      !error &&
                      data &&
                      data.getPageBuilder &&
                      data.getPageBuilder.detail
                    ) {
                      const detail = data.getPageBuilder.detail;
                      return (
                        <Push>
                          <img src={data.getPageBuilder.img_desktop} />
                          <Text
                            variant="heading3"
                            as="p"
                            color={theme.color.brand.primary}
                          >
                            {detail.title}
                          </Text>
                          {/* <Link
                            href={`/${i18n.language}/${pathname}/${
                              detail.slug
                            }/`}
                          >
                            {t('common:place.see')}{' '}
                            <Icon name={'arrow-right'} />
                          </Link> */}
                          <Button href={`${pathname}/${detail.slug}`}>
                            {t('common:place.see')}
                          </Button>
                        </Push>
                      );
                    }

                    return null;
                  }}
                </Query>
              </Column>
              <Column mobile={2} desktop={4} space={10}>
                <Query
                  query={getPageBuilderByType}
                  context={createContext(i18n.language)}
                  variables={{ type: 'audioguide' }}
                >
                  {({ loading, error, data }) => {
                    if (
                      !loading &&
                      !error &&
                      data &&
                      data.getPageBuilder &&
                      data.getPageBuilder.detail
                    ) {
                      const detail = data.getPageBuilder.detail;
                      return (
                        <Push>
                          <img src={data.getPageBuilder.img_desktop} />
                          <Text
                            variant="heading3"
                            as="p"
                            color={theme.color.brand.primary}
                          >
                            {detail.title}
                          </Text>
                          {/* <Link
                            href={`/${i18n.language}/${pathname}/${
                              detail.slug
                            }/`}
                          >
                            {t('common:place.see')}{' '}
                            <Icon name={'arrow-right'} />
                          </Link> */}
                          <Button href={`${pathname}/${detail.slug}`}>
                            {t('common:place.see')}
                          </Button>
                        </Push>
                      );
                    }

                    return null;
                  }}
                </Query>
              </Column>
              <Column mobile={2} desktop={4} space={10}>
                <Query
                  query={getPageBuilderByType}
                  context={createContext(i18n.language)}
                  variables={{
                    type: 'cig'
                  }}
                >
                  {({ loading, error, data }) => {
                    if (
                      !loading &&
                      !error &&
                      data &&
                      data.getPageBuilder &&
                      data.getPageBuilder.detail
                    ) {
                      const detail = data.getPageBuilder.detail;
                      return (
                        <Push>
                          <img src={data.getPageBuilder.img_desktop} />
                          <Text
                            variant="heading3"
                            as="p"
                            color={theme.color.brand.primary}
                          >
                            {detail.title}
                          </Text>
                          {/* <Link
                            href={`/${i18n.language}/${pathname}/${
                              detail.slug
                            }/`}
                          >
                            {t('common:place.see')}{' '}
                            <Icon name={'arrow-right'} />
                          </Link> */}
                          <Button href={`${pathname}/${detail.slug}`}>
                            {t('common:place.see')}
                          </Button>
                        </Push>
                      );
                    }

                    return null;
                  }}
                </Query>
              </Column>
              <Column mobile={2} desktop={4} space={10}>
                <Query
                  query={getPageBuilderByType}
                  context={createContext(i18n.language)}
                  variables={{
                    type: 'enigmes'
                  }}
                >
                  {({ loading, error, data }) => {
                    if (
                      !loading &&
                      !error &&
                      data &&
                      data.getPageBuilder &&
                      data.getPageBuilder.detail
                    ) {
                      const detail = data.getPageBuilder.detail;
                      return (
                        <Push>
                          <img src={data.getPageBuilder.img_desktop} />
                          {/* <span>{detail.title}</span> */}
                          <Text
                            variant="heading3"
                            as="p"
                            color={theme.color.brand.primary}
                          >
                            {detail.title}
                          </Text>
                          {/* <Link
                            href={`/${i18n.language}/${pathname}/${
                              detail.slug
                            }/`}
                          >
                            {t('common:place.see')}{' '}
                            <Icon name={'arrow-right'} />
                          </Link> */}
                          <Button href={`${pathname}/${detail.slug}`}>
                            {t('common:place.see')}
                          </Button>
                        </Push>
                      );
                    }

                    return null;
                  }}
                </Query>
              </Column>
            </Row>
          </Fade>
        </Container>
      </Section>
    );
  }
}

export default translate()(PushDiscover);
